module.exports = __webpack_public_path__ + "img/potable-water.8da0c1f2.png";